import "./App.css";
import { Calculator } from "./Component/Calculator/Calculator";
function App() {
  return (
    <>
      <div>
        <Calculator />
      </div>
    </>
  );
}
export default App;